// DOM

const showElement = element => {
    element.removeAttribute('hidden');
};

const hideElement = element => {
    element.setAttribute('hidden', 'hidden');
};

// PWA

const appInstallationButtons = document.getElementsByClassName('js-app-install');

window.addEventListener('load', () => {
    if ('serviceWorker' in navigator) {
        navigator.serviceWorker.register('/service-worker.js');

        [].forEach.call(appInstallationButtons, appInstallationButton => {
            showElement(appInstallationButton);
        });
    }
});

let deferredPrompt;

window.addEventListener('beforeinstallprompt', event => {
    event.preventDefault();
    deferredPrompt = event;
});

[].forEach.call(appInstallationButtons, appInstallationButton => {
    appInstallationButton.addEventListener('click', event => {
        hideAppInstallationButtons();
        return showAppInstallPrompt();
    });
});

const hideAppInstallationButtons = () => {
    [].forEach.call(appInstallationButtons, appInstallationButton => {
        hideElement(appInstallationButton);
    });
}

const showAppInstallPrompt = async () => {
    deferredPrompt.prompt();
    const { outcome } = await deferredPrompt.userChoice;
    deferredPrompt = null;
    console.log(`User response to the install prompt: ${outcome}`);

    axios.post('/actions/dismissAppInstallPrompt').then(response => {
        //
    });
};

window.addEventListener('appinstalled', () => {
    hideAppInstallationButtons();
    deferredPrompt = null;
    console.log('App was installed');
});

const getPWADisplayMode = () => {
    const isStandalone = window.matchMedia('(display-mode: standalone)').matches;

    if (document.referrer.startsWith('android-app://')) {
        return 'twa';
    } else if (navigator.standalone || isStandalone) {
        return 'standalone';
    }

    return 'browser';
}
